import React from 'react';
import styled from 'styled-components';
import { FiCalendar } from 'react-icons/fi';

const InputContainer = styled.div`
  position: relative;
  min-width: 140px;
  flex: 0 0 auto;
  
  @media (max-width: 768px) {
    min-width: 120px;
  }
  
  @media (max-width: 640px) {
    min-width: 100px;
  }
  
  @media (max-width: 480px) {
    min-width: 80px;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 40px 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 0;
  background: var(--background-primary);
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary);
  transition: border-color 0.2s ease;
  height: 48px;

  &:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 3px var(--focus-ring);
  }

  &:disabled {
    background: var(--background-secondary);
    color: var(--text-muted);
    cursor: not-allowed;
  }
  
  @media (max-width: 640px) {
    height: 40px;
    padding: 8px 36px 8px 12px;
    font-size: 14px;
  }
  
  @media (max-width: 480px) {
    height: 36px;
    padding: 6px 32px 6px 10px;
    font-size: 13px;
  }
  
  @media (max-height: 600px) {
    height: 40px;
    padding: 8px 36px 8px 12px;
    font-size: 14px;
  }
  
  @media (max-height: 500px) {
    height: 36px;
    padding: 6px 32px 6px 10px;
    font-size: 14px;
  }
`;

const InputIcon = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
  
  @media (max-width: 640px) {
    right: 12px;
  }
  
  @media (max-width: 480px) {
    right: 10px;
  }
  
  @media (max-height: 600px) {
    right: 12px;
  }
  
  @media (max-height: 500px) {
    right: 10px;
  }
`;

export default function WeekSelect({ value, onChange, disabled = false, placeholder = "Week number..." }) {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Allow empty input or positive integers
    if (inputValue === '') {
      onChange(null);
    } else {
      const numValue = parseInt(inputValue);
      if (!isNaN(numValue) && numValue > 0) {
        onChange(numValue);
      }
    }
  };

  return (
    <InputContainer>
      <Input
        type="number"
        min="1"
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
      />
      <InputIcon>
        <FiCalendar size={16} />
      </InputIcon>
    </InputContainer>
  );
}
